import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import GtmPageTypeContext from './GtmPageTypeContext';

import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

export default class GtmPageTypeProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    gtmPageType: PropTypes.string,
  };

  static defaultProps = {
    gtmPageType: gtmPageTypes.Other,
  };

  render() {
    const { gtmPageType } = this.props;
    return (
      <GtmPageTypeContext.Provider value={{ gtmPageType }}>
        {this.props.children}
      </GtmPageTypeContext.Provider>
    );
  }
}
